import React from 'react';
import LoadingApp from 'lqa-ui/lib/Components/LoadingApp';

export const SignOutButton = () => {
    return (
      <LoadingApp />
    );
};
